import { createSlice } from '@reduxjs/toolkit';

import { assignDefinedFields } from '@polyai/stream/store/utils/assign-fields';
import { assignMetadata } from '@polyai/stream/store/utils/assign-metadata';

import { updateRole } from '../actions';
import { ROLE_INITIAL_STATE } from '../constants';

const slice = createSlice({
  name: 'role',
  initialState: ROLE_INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateRole, (state, action) => {
      assignDefinedFields(state, action.payload);
      assignMetadata(action, state);
    });
  },
});

export default slice.reducer;
